import { AssetState } from '@/api/generatedApi';
import { TraceIdLoadingRow, TraceIdRow } from '@/components/FailureDiagnostics/TraceIdRow';
import { useGetAssetFailureDiagnostics } from '@/hooks/api/assets/useGetAssetFailureDiagnostics';
import { AssetErrorMessage } from './AssetErrorMessage';

export const FailedAssetMessage = ({ assetId }: { assetId?: string }) => {
  const { data, isLoading } = useGetAssetFailureDiagnostics({ assetId: assetId ?? '', enabled: true });
  const traceId = data?.status === 'found' ? data.traceId : undefined;

  return (
    <AssetErrorMessage assetState={AssetState.Failed}>
      {isLoading && <TraceIdLoadingRow />}
      {traceId && <TraceIdRow traceId={traceId} />}
    </AssetErrorMessage>
  );
};
